module.exports = "/assets/81e3d7014115eb52b6dfdffcb6d7cf75.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/KA.png
// module id = 1538
// module chunks = 0